"use client";
import { cn } from "@/lib/cn";
import React from "react";
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";

interface numberInputInterface {
  name: string;
  label: string;
  value: any;
  setValue: any;
  disabled: boolean;
}
const NumberInput = ({
  name,
  label,
  value = 0,
  setValue,
  disabled,
}: numberInputInterface) => {
  return (
    <div className="flex flex-col rounded-full">
      <label htmlFor={label} className="text-base mb-2">
        {label}
      </label>
      <div className="py-1 px-4 flex justify-between items-center bg-white text-black rounded-full">
        <button
          aria-label="decrement-quantity"
          onClick={(e) => {
            e.preventDefault();
            !disabled && setValue(parseInt(value) - 1);
          }}
          className={cn("cursor-pointer", disabled ? "text-gray-400" : "")}
        >
          <FaMinus size={18} />
        </button>

        <input
          type="number"
          value={value}
          className={cn(
            "w-24 select-none text-lg text-center border-none outline-none",
            "cursor-pointer",
            disabled ? "text-gray-400" : ""
          )}
          onChange={(e) => setValue(parseInt(e.target.value))}
        />

        <button
          onClick={(e) => {
            e.preventDefault();
            !disabled && setValue(parseInt(value) + 1);
          }}
          aria-label="increment-quantity"
          className={cn("cursor-pointer", disabled ? "text-gray-400" : "")}
        >
          <FaPlus size={18} />
        </button>
      </div>
    </div>
  );
};

export default NumberInput;
